// store.js
import { writable } from 'svelte/store';

// Crée un store writable avec une valeur initiale
export const workingDays = writable(21);

export const api_url = writable('');

export const api_url_public = writable('');

export const globalState = writable({
    a: null,
    b: 2,
    c: 0,
    d: null,
    e: 0,
    f: 0,
    g: 4.5,
    h: 21,
    i: "Salaire brut mensuel",
    j: "",
    k: "1",
    l: 'a',
    m: 1,
    n: null,
    o: null,
    p: null,
    q: 1,
    r: 0,
    s: 0,
});